import {
  CButton,
  CCardHeader,
  CCol,
  CForm,
  CInput,
  CInputGroup,
  CLabel,
  CRow,
} from "@coreui/react";
import React, { useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import Auth from "src/auth";
import { apiCall } from "src/_apiConfig/apiCall";

const OfflinePayment = () => {
  const { authenticated } = Auth();
  const { lotTransferId } = useParams("lotTransferId");
  const [selectedFile, setSelectedFile] = useState();
  const [amount, setamount] = useState();
  const history = useHistory();

  const submitHandler = async (e) => {
    e.preventDefault();
    const header = new Headers();
    const data = new FormData();
    data.append("file", selectedFile);
    header.append("Accept", "application/json");
    const response = await apiCall(
      `OfflinePayment/Upload`,
      "POST",
      header,
      data
    );
    const jsonobj = await response.json();
    if (response.status === 200) {
      header.append("Content-Type", "application/json");
      const uploadResponse = await apiCall(
        `OfflinePayment/Add`,
        "POST",
        header,
        JSON.stringify({
          type: 1,
          amount: Number(amount),
          objectId: Number(lotTransferId),
          userId: authenticated.userId,
          filePath: jsonobj,
        })
      );
      const uploadjsonobj = await uploadResponse.json();
      if (
        uploadResponse.status === 200 &&
        uploadjsonobj !== -1 &&
        uploadjsonobj !== -2
      ) {
        history.push("/lotlist");
      }
    }
  };

  return (
    <>
      <CCardHeader className="mb-3 shadow-sm">
        <CRow className="pt-3" xl={12}>
          <CCol xl={10}>
            <h3>Offline Payment</h3>
          </CCol>
        </CRow>
        <hr />
        <CForm className="needs-validation">
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
                Upload Payment Receipt :
              </CLabel>
            </CCol>

            <CCol xl={4}>
              <CInputGroup className="mb-3">
                <div className="custom-file">
                  <input
                    id="inputGroupFile01"
                    type="file"
                    accept=".jpg, .jpeg, .png"
                    className="custom-file-input"
                    onChange={(e) => {
                      setSelectedFile(e.target.files[0]);
                    }}
                  />
                  <label
                    className="custom-file-label "
                    htmlFor="inputGroupFile01"
                  >
                    {selectedFile ? selectedFile.name : <>Choose file</>}
                  </label>
                </div>
              </CInputGroup>
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom20"
                className="col-sm-12 col-form-label"
              >
                Amount :
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                min="1"
                type="number"
                onChange={(e) => {
                  setamount(e.target.value < 0 ? 0 : e.target.value);
                }}
                id="validationCustom20"
                value={amount ? amount : " "}
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol xl={2}>
              <CButton
                className="ml-3"
                type="submit"
                onClick={submitHandler}
                disabled={selectedFile && amount ? false : true}
                color="success"
              >
                Submit
              </CButton>
            </CCol>
          </CRow>{" "}
        </CForm>
      </CCardHeader>
    </>
  );
};
export default OfflinePayment;
